import { useDocumentTitle } from '@leagueplatform/web-common';

export function useHealthMetricDocumentTitle(
  pageName: string,
  metricDisplayName?: string,
) {
  let pageTitle = pageName;

  // Prepend the metric display name to the page title.
  if (metricDisplayName) {
    pageTitle = `${metricDisplayName} | ${pageTitle}`;
  }

  useDocumentTitle(pageTitle);
}
